export default __webpack_public_path__ + "static/media/Adora.57f0a5e0.webp";